
import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Bell, History, ChevronRight, Clock, Home } from "lucide-react";
import { useSidebar } from "@/components/ui/sidebar";
import { Button } from "@/components/ui/button";
import { formatCurrentTime } from "@/lib/utils";
import { Separator } from "@/components/ui/separator";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

const TopNavbar: React.FC = () => {
  const location = useLocation();
  const {
    state,
    toggleSidebar
  } = useSidebar();
  const isCollapsed = state === "collapsed";
  const [currentDateTime, setCurrentDateTime] = useState<string>(new Date().toLocaleString('en-US', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true
  }));

  // Update time every second
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDateTime(new Date().toLocaleString('en-US', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
      }));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  // Staff and outlet info
  const staffName = "Amirul";
  const staffRole = "Cashier";
  const currentShift = "Morning";
  const shiftTime = "08:00 - 16:00";
  const outletName = "Jimat Mart Ampang";
  return <div className="sticky top-0 z-10 w-full bg-background  shadow-sm">
      <div className="flex items-center justify-between px-4 py-2">
        <div className="flex items-center space-x-4">
          {isCollapsed && <Button variant="ghost" size="icon" onClick={toggleSidebar} className="text-muted-foreground hover:text-foreground">
              <ChevronRight className="h-4 w-4" />
              <span className="sr-only">Expand Sidebar</span>
            </Button>}
          
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button variant="ghost" size="icon" asChild className="mr-2">
                  <Link to="/dashboard/">
                    <Home className="h-4 w-4" />
                    <span className="sr-only">Home</span>
                  </Link>
                </Button>
              </TooltipTrigger>
              <TooltipContent>
                <p>Home</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
          
          <div className="flex items-center">
            <span className="font-medium">Outlet:</span>
            <span className="ml-1">{outletName}</span>
          </div>
        </div>
        
        <div className="flex items-center space-x-4 text-sm text-muted-foreground">
          <div className="flex items-center">
            <Clock className="h-3.5 w-3.5 mr-1" />
            <span>{currentDateTime}</span>
          </div>
          <Separator orientation="vertical" className="h-6" />
          <div>
            <span className="font-medium">Staff:</span>
            <span className="ml-1">{staffName} ({staffRole})</span>
          </div>
          <div>
            <span className="font-medium">Shift:</span>
            <span className="ml-1">{currentShift} ({shiftTime})</span>
          </div>
        </div>
        
        <div className="flex items-center space-x-2">
          <Button variant="ghost" size="icon" className="relative">
            <Bell className="h-4 w-4" />
            <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
            <span className="sr-only">Notifications</span>
          </Button>
          <Button variant="ghost" size="icon">
            <History className="h-4 w-4" />
            <span className="sr-only">Bill History</span>
          </Button>
        </div>
      </div>
    </div>;
};
export default TopNavbar;
